import { types as t, flow } from 'mobx-state-tree';

import timezonesApi from 'shared/api/timezones';

export const Timezone = t.model('Timezone', {
  id: t.number,
  code: t.maybe(t.string),
  shift: t.string,
  name: t.optional(t.string, ''),
});

const BaseTimezonesModel = t.model('BaseTimezonesModel', {});

const TimezonesModel = t.model('TimezonesModel', {
  timezones: t.optional(t.array(Timezone), []),
});

export const TimezonesDataModel = t
  .compose(BaseTimezonesModel, TimezonesModel)
  .actions(self => ({
    fetchTimezones: flow(function* fetchTimezones() {
      const response = yield timezonesApi.getTimezones();
      if (response && response.data && response.data.items) {
        const normalized = response.data.items.map((item: any) => ({
          ...item,
          code: item?.code ?? '',
          shift: item?.shift ?? '',
        }));
        self.timezones = normalized as any;
      }
      return response;
    }),
  }));
